// extracted by mini-css-extract-plugin
export var two_column_callout = "two_column_callout-XAu";
export var callout_content = "callout_content-1JL";
export var callout_image = "callout_image-2yW";